import {Reducer} from 'redux'
import {EmployeesActionTypes, EmployeesState} from './types';
import EmployeesService from "../../services/EmployeesService";

// Type-safe initialState!
const initialState: EmployeesState = {
	list: []
}

// Thanks to Redux 4's much simpler typings, we can take away a lot of typings on the reducer side,
// everything will remain type-safe.
const reducer: Reducer<EmployeesState> = (state = initialState, action) => {
	switch (action.type) {
		case EmployeesActionTypes.FETCH_ALL_REQUEST: {
			EmployeesService.getAll()
			return { ...state, loading: true }
		}
		case EmployeesActionTypes.FETCH_ALL_COMPLETED: {
			return { ...state, loading: false, list: action.payload}
		}
		case EmployeesActionTypes.FETCH_ONE_REQUEST: {
			EmployeesService.getOne(action.payload)
			return { ...state, loading: true }
		}
		case EmployeesActionTypes.FETCH_ONE_COMPLETED: {
			let foundIndex = state.list.findIndex(element => element.id === action.payload.id)
			state.list.splice(foundIndex, 1, action.payload)
			let newList = [...state.list]
			return { ...state, loading: false, list: newList}
		}
		case EmployeesActionTypes.SAVE_REQUEST: {
			EmployeesService.save(action.payload)
			return { ...state, loading: true }
		}
		case EmployeesActionTypes.SAVE_COMPLETED: {
			console.log(action.payload)
			return { ...state, loading: false}
		}
		case EmployeesActionTypes.DELETE_REQUEST: {
			EmployeesService.delete(action.payload)
			return { ...state, loading: true }
		}
		case EmployeesActionTypes.DELETE_COMPLETED: {
			let foundIndex = state.list.findIndex(element => element.id === action.payload.id)
			state.list.splice(foundIndex, 1)
			let newList = [...state.list]
			return { ...state, loading: false, list: newList}
		}
		case EmployeesActionTypes.DELETE_MULTIPLE_REQUEST: {
			EmployeesService.deleteMultiple(action.payload)
			return { ...state, loading: true }
		}
		case EmployeesActionTypes.DELETE_MULTIPLE_COMPLETED: {
			action.payload.forEach((item: any) => {
				let foundIndex = state.list.findIndex(element => element.id === item.id)
				state.list.splice(foundIndex, 1)
			});
			let newList = [...state.list]
			return { ...state, loading: false, list: newList}
		}
		default: {
			return state
		}
	}
}

// Instead of using default export, we use named exports. That way we can group these exports
// inside the `index.js` folder.
export {reducer as EmployeesReducer}
